import { Component, Inject, OnInit } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import {FormControl, FormGroup} from '@angular/forms';
import { HistorialService } from 'src/app/services/historial.service';

HistorialService

@Component({
  selector: 'app-dialogprehistorial',
  templateUrl: './dialogprehistorial.component.html',
  styleUrls: ['./dialogprehistorial.component.css']
})
export class DialogprehistorialComponent implements OnInit {

 

  folioinicial="";
  foliofinal="";

  constructor(
    @Inject (MAT_DIALOG_DATA) public message,
    public dialogRef : MatDialogRef <DialogprehistorialComponent>, 
    private historialService:HistorialService
  ) { }

  ngOnInit() {
  }

  foliohistoricos() {
    

        // let fechainicial= moment(res.date._d).format("yyyy-MM-DD");
        // var fechafinal= moment(res.serializedDate._d).format("yyyy-MM-DD");



      this.historialService.transfiereHistorial(this.folioinicial , this.foliofinal)
      .subscribe (resp=>{
        console.log (resp)
      })
      
  }

}
